const Documentation = () => {
  return <div>Documentation page</div>
}

export { Documentation }
